import { useCallback } from 'react';
import { useTenant } from '@packlink/tenant-provider';
import qs from 'qs';

import { removeToken } from '@utils';

type UseLogout = () => void;
/**
 * @return doLogout -> Function to perform the logiut action
 */
export const useLogout = (): UseLogout => {
    const tenant = useTenant();

    const onboardingStartUrl = `/auth-gateway/onboarding/start?${qs.stringify({
        tenant_id: tenant.name,
        return_url: window.location.href,
    })}`;

    const doLogout = useCallback((): void => {
        removeToken();
        window.location.replace(onboardingStartUrl);
    }, [onboardingStartUrl]);

    return doLogout;
};
